import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardHeader, CardContent, Divider, Grid, Typography } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { getChartColors, CHANNEL_PALETTE, CHANNEL_OTHER_COLOR } from '../../../../utils/chartTheme';
import { dashboardCardSx } from '../card-style';

const ChannelDonut = memo(function ChannelDonut(props) {
  const { data, intl } = props;
  const colors = getChartColors();

  const all = (data || [])
    .map(item => ({ name: item.originrequestname, value: item.count || 0 }))
    .sort((a, b) => b.value - a.value);

  // A paleta tem ordem fixa e nao e ciclada: com mais canais que cores, repetir a primeira cor
  // faria dois canais diferentes parecerem o mesmo. Os que passam do tamanho da paleta viram
  // uma fatia "Outros" -- que a legenda nomeia, entao nada some do total.
  const othersLabel = intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.others', defaultMessage: 'Outros' });
  const head = all.slice(0, CHANNEL_PALETTE.length);
  const tail = all.slice(CHANNEL_PALETTE.length);
  const chartData = tail.length > 0
    ? [...head, { name: othersLabel, value: tail.reduce((sum, item) => sum + item.value, 0), isOthers: true }]
    : head;

  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  const colorAt = (entry, index) => (entry.isOthers ? CHANNEL_OTHER_COLOR : CHANNEL_PALETTE[index]);
  const percentOf = value => (total > 0 ? Math.round((value / total) * 100) : 0);

  return (
    <Card sx={dashboardCardSx}>
      <CardHeader
        avatar={<span style={{ color: colors.warning, display: 'flex' }}><HubIcon /></span>}
        title={intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.title', defaultMessage: 'Atendimentos por canal' })} />
      <Divider />
      <CardContent>
        {total === 0 && (
          <Typography variant="body2" color="textSecondary">
            {intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.empty', defaultMessage: 'Nenhum atendimento no período selecionado' })}
          </Typography>
        )}
        {total > 0 && (
        <Grid container alignItems="center">
          <Grid item xs={12} md={7}>
            <div style={{ width: '100%', height: 260 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={60}
                    outerRadius={90}
                    paddingAngle={2}
                    isAnimationActive={false}
                  >
                    {chartData.map((entry, index) => (
                      <Cell
                        key={`channel-cell-${index}`}
                        fill={colorAt(entry, index)}
                        stroke="#ffffff"
                        strokeWidth={2}
                      />
                    ))}
                  </Pie>
                  {/* O numero sozinho nao responde "isso e muito?"; o percentual do periodo responde. */}
                  <Tooltip formatter={value => `${value} (${percentOf(value)}%)`} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <Typography variant="h4" align="center">{total}</Typography>
            <Typography variant="caption" color="textSecondary" display="block" align="center" gutterBottom>
              {intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.total', defaultMessage: 'atendimentos' })}
            </Typography>
            {chartData.map((item, index) => (
              <Grid
                container
                key={`channel-legend-${index}`}
                justifyContent="space-between"
                style={{ marginTop: 4 }}
              >
                <Grid item>
                  <span
                    className="mexx-dyn-bg"
                    style={{
                      display: 'inline-block', width: 10, height: 10, borderRadius: 2, marginRight: 6,
                      '--mexx-dyn-bg': colorAt(item, index)
                    }}
                  />
                  <Typography variant="body2" component="span">{item.name}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2" component="span">
                    {item.value} ({percentOf(item.value)}%)
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
        )}
      </CardContent>
    </Card>
  );
});

export default injectIntl(ChannelDonut);
